import { defineComponent } from 'vue'
import seoService from '../services/seo'

export default defineComponent({
  methods: {
    setPageSEO (config: any) {
      seoService.setSEO(config)
    },

    setPropertySEO (property: any) {
      seoService.setPropertySEO(property)
    },

    setBreadcrumbSEO (breadcrumbs: Array<{ name: string; url?: string }>) {
      seoService.setBreadcrumbSEO(breadcrumbs)
    },

    setHomeSEO () {
      seoService.setHomeSEO()
    },

    setPropertiesListSEO (filters?: any) {
      seoService.setPropertiesListSEO(filters)
    },

    setAboutSEO () {
      seoService.setAboutSEO()
    },

    setContactSEO () {
      seoService.setContactSEO()
    }
  }
})
